// Contrôle de format d'un numéro d'entreprise français (aide à la vérification par l'admin).
// SIREN = 9 chiffres, SIRET = 14 chiffres, clé de Luhn. Les autres numéros (RCCM, NINEA…) sont vérifiés à la main.
const luhn = (digits) => {
  let sum = 0;
  for (let i = 0; i < digits.length; i += 1) {
    let d = Number(digits[digits.length - 1 - i]);
    if (i % 2 === 1) { d *= 2; if (d > 9) d -= 9; }
    sum += d;
  }
  return sum % 10 === 0;
};

/** { kind: 'SIRET' | 'SIREN' | null, valid: bool } — kind null : pas un numéro français. */
export function frenchCompanyNumber(value) {
  const raw = (value || '').trim();
  if (!/^[\d\s.]+$/.test(raw)) return { kind: null, valid: false };
  const digits = raw.replace(/\D/g, '');
  const kind = digits.length === 14 ? 'SIRET' : digits.length === 9 ? 'SIREN' : null;
  return { kind, valid: !!kind && luhn(digits) };
}
